window.addEventListener('load', event => {
    // Mobile nav
    let mobileNavToggle = document.getElementById('mobileNavToggle');
    let mobileNavigation = document.getElementById('mobileNavigation');
    let open = false;
    let mobileNavDropdownToggle = document.querySelectorAll('.mobile-nav-dropdown-toggle');

    if (mobileNavToggle && mobileNavigation) {
        mobileNavToggle.addEventListener('click', () => {

            let shadowElement = mobileNavToggle.querySelector('.toggle-shadow');

            if (open) {
                enableBodyScroll(mobileNavigation);
                open = false;
            } else {
                disableBodyScroll(mobileNavigation);
                open = true;
            }

            shadowElement.classList.toggle('!shadow-realistic-offset');

            mobileNavToggle.classList.toggle('active');
            mobileNavigation.classList.toggle('active');

            for (let navDropdown of mobileNavDropdownToggle) {
                let mobileNavDropdownContent = navDropdown.closest('li').nextElementSibling;
                navDropdown.querySelector('svg').classList.remove('-scale-x-100');
                mobileNavDropdownContent.classList.add('!max-h-0');
                mobileNavDropdownContent.classList.remove('opacity-100');
            }
        });
    }

    for (let navDropdown of mobileNavDropdownToggle) {
        let mobileNavDropdownContent = navDropdown.closest('li').nextElementSibling;
        navDropdown.addEventListener('click', () => {
            navDropdown.querySelector('svg').classList.toggle('-scale-x-100');
            mobileNavDropdownContent.classList.toggle('!max-h-0');
            mobileNavDropdownContent.classList.toggle('opacity-100');
        });
    }

    // Desktop nav
    let desktopNavDropdownContent = document.querySelectorAll('.desktop-nav-dropdown-content');

    // Keeps land dropdown nav hidden for 500ms on page load to mask transitions
    for (let navDropdown of desktopNavDropdownContent) {
        setTimeout(function() {
            navDropdown.classList.remove('hidden');
        }, 500);
    }
});